module.exports = __webpack_public_path__ + "img/decor-item-countdown.afcf7887.svg";